"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _PropagateLoader = _interopRequireDefault(require("react-spinners/PropagateLoader"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function HiLoader(props) {
  var className = props.className,
    color = props.color,
    size = props.size,
    theme = props.theme,
    style = props.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "hi-loader",
    className: className,
    style: (0, _objectSpread2.default)({}, style, {
      display: 'block',
      width: 1,
      height: 12
    })
  }, /*#__PURE__*/_react.default.createElement(_PropagateLoader.default, {
    size: size,
    color: theme.palette[color].main
  }));
}
HiLoader.defaultProps = {
  size: 12,
  color: 'primary'
};
var _default = exports.default = (0, _withStyles.default)({}, {
  hiComponent: true,
  withTheme: true,
  name: 'HmuiHiLoader'
})(HiLoader);